import React, { useState, useEffect } from 'react';
import { FaArrowUpLong } from "react-icons/fa6";
import wp from "../assets/Upload/whatsapp.png";

export default function FloatingActions() {
  const [isVisible, setIsVisible] = useState(false);

  // Show/hide back-to-top button based on scroll position
  useEffect(() => {
    const handleScroll = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      {/* WhatsApp Floating Button */}
      <div className="sticky-whatsapp">
        <a
          href="https://api.whatsapp.com/send?phone=9139989898&text=%20Hello%20The%20Clay%20World%20School%20Team,%20I%20am%20interested%20in%20-"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img 
            style={{ height: "50px" }} 
            src={wp} 
            className="img-responsive" 
            alt="WhatsApp" 
          />
        </a>
      </div>

      {/* Mandatory Disclosure Floating Button */}
      <div className='createCatelogDiv'>
        <a href='/mandatorydisclosure' className='catalogue-vertical'>
          Mandatory Disclosure
        </a>
      </div>

      {/* Back to Top Button - Only shows when scrolled down */}
      {isVisible && (
        <div 
          id="back-to-top" 
          className="back-to-top" 
          onClick={scrollToTop}
        >
          <FaArrowUpLong />
        </div>
      )}
    </>
  );
}